import { ReactNode } from 'react'
import './index.scss'
export default function Index({ text,color='green',notmt }: {
    text: string | ReactNode,
    color?:'blue'|'green',
    notmt?:"notmt"
}) {
    return <div className={`pricePanel ${color} ${notmt}`}>
        {text}
    </div>
}